module.exports = __webpack_public_path__ + "Yfz3EKkuEAXohMTFW/black-x.svg";